import { render } from "./Entries.vue?vue&type=template&id=3913a386"
import script from "./Entries.vue?vue&type=script&lang=js"
export * from "./Entries.vue?vue&type=script&lang=js"

import exportComponent from "C:\\VS2022\\kirchenbote-online-2022_01\\MD.RMP.KirchenboteOnline.Umb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/multiMostRead/Entries.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3913a386"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3913a386', __exports__)) {
    api.reload('3913a386', __exports__)
  }
  
  module.hot.accept("./Entries.vue?vue&type=template&id=3913a386", () => {
    api.rerender('3913a386', render)
  })

}


export default __exports__